import { render, staticRenderFns } from "./SurveyUser.vue?vue&type=template&id=5a138876&scoped=true&"
import script from "./SurveyUser.vue?vue&type=script&lang=js&"
export * from "./SurveyUser.vue?vue&type=script&lang=js&"
import style0 from "./SurveyUser.vue?vue&type=style&index=0&id=5a138876&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a138876",
  null
  
)

export default component.exports